import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AdsGETApiAuth, AdsPUTApi, ImageURL, UserMeEdit } from '../../Constant/api';
import { slugs } from '../../Constant/slugs';
import { login, logout } from '../../redux/action';
import store from '../../redux/store';
import ImageUpload from '../ImageUpload';
import SideBar from '../SideBar';
import axios from 'axios'
import fileDownload from 'js-file-download'
export default function Profile() {
  const Login = useSelector((state) => state.LoginState);
  const dispatch = useDispatch()
  const [Name, setName] = React.useState("")
  const [Photo, setPhoto] = React.useState("")
  const [PhoneNumber, setPhoneNumber] = React.useState("")
  const [user, setUser] = React.useState({ roles: ['subscriber'] })
  const [userDetails, setUserDetails] = React.useState({})
  const [usersDataID, setusersDataID] = React.useState("")
  const [UserFetch, setUserFetch] = React.useState(false)
  const [BatchStatus, setBatchStatus] = React.useState("")
  const [SubscriptionPressed, setSubscriptionPressed] = React.useState(false)
  const [PaymentMethod, setPaymentMethod] = React.useState("")
  const [ScreenShotUrl, setScreenShotUrl] = React.useState("")
  const [SubscriptionVerifyDone, setSubscriptionVerifyDone] = React.useState(false)
  const [reload, setReload] = React.useState(false)
  const [BankImageSelect, setBankImageSelect] = React.useState(false)
  const [BankImageUrl, setBankImageUrl] = React.useState("")
  const [ImageSelect, setImageSelect] = React.useState("")

  const LoginState = useSelector((state) => state.LoginState);
  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")
  const [editProfileModal, setEditProfileModal] = React.useState(false)

  const UserDetails = () => {
    setUserFetch(false)
    setReload(true)
    const id = Login.userID
    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": id,
      "filter[meta_query][1][compare]": "=",
      _fields: "title,meta,slug,id"
    }, "user_data")
      .then((response) => {
        if (response.data.length !== 0) {
          setUserDetails(response.data[0])
          setUserFetch(true)
          if (response.data[0].meta.batch_id !== "")
            AdsGETApiAuth({ _fields: "id,meta.batch_status" }, `${slugs.db_slug_batch}/${response.data[0].meta.batch_id}`)
              .then(res => {
                setBatchStatus(res.data.meta.batch_status)
              })

          if (response.data[0].meta.batch_id == Login.userBatch)
            console.log("same")
          else {
            dispatch(login(
              `${Login.userID}`,
              `${Login.userName}`,
              `${Login.token}`,
              `${Login.userEmail}`,
              `${response.data[0].meta.user_role}`,
              `${response.data[0].meta.user_profile_picture}`,
              `${response.data[0].meta.user_phone_number}`,
              `${response.data[0].meta.batch_id}`,
            ))
          }
        }
        else {
          dispatch(logout())
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setReload(false)
      })
  }
  const EditUser = () => {
    setReload(true)
    AdsPUTApi(
      {
        meta: {
          user_profile_picture_user: Photo,
          user_phone_number: PhoneNumber
        }
      },
      "users_data", usersDataID
    ).then(res => {
      setReload(false)
    }).catch(() => {

    })
  }
  const UserDetailsSubscriptionEdit = () => {
    setReload(true)
    const date = new Date();
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    const data2 = {}

    console.log(usersDataID)
    AdsPUTApi(data2, "users_data", usersDataID)
      .then((res) => {
        setReload(false)
        setSubscriptionVerifyDone(true)
        console.log(res.data)
      }).catch((err) => {
        console.warn(err);
        console.warn(err.response.data);
      })
  }
  useEffect(() => {
    UserDetails()
  }, [])
  const AlertComponent = () => {
    return (
      <div className="modal"
        onClick={() => {
        }}
      >
        <div>
          <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
            <div className="col-lg-4 col-1"></div>
            <div className="col-lg-4 col-10 pb-5  bg-white  shadow">
              <div className="p-5">
                <div dangerouslySetInnerHTML={{ __html: Alertcomp }}></div>
              </div>
              <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                <div className="sign-in-button-1 col-8">
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        console.log(res)
        fileDownload(res.data, filename)
      })
  }
  const [base64, setBase64] = React.useState("")
  const downloadImage = async (imageurl, filename) => {
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const imageUrl = "https://api.oppaonnihakwon.com/wp-content/uploads/2025/01/BUTAB.jpeg";
    var nodejsurl = "https://real-exam.epsexam.com/base64"
    axios({ method: "GET", url: `${nodejsurl}?url=${imageurl}` })
      .then(res => {
        const link = document.createElement("a");
        link.href = `data:image/jpeg;base64,${res.data.data}`;
        link.download = filename;
        // setBase64(`data:image/jpeg;base64,${res.data.data}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
  };
  const DownloadImage = (fileURL) => {
    fetch(fileURL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `FileName.pdf`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });
  }
  return (
    <div>

      {UserFetch &&
        <>
          <div className="row">
            <div className="col-2">
            </div>
            <section className="col-8 form-view mt-3">
              <center style={{ margin: "10px" }}>
                {userDetails.meta.user_profile_picture !== "" ?
                  <img src={userDetails.meta.user_profile_picture}
                    style={{ width: "100px", height: "100px", borderRadius: "100px", border: "1px solid black" }}
                  />
                  :
                  <div className="center"
                    style={{ fontSize: "70px", width: "100px", height: "100px", borderRadius: "100px", border: "1px solid black" }}
                  >
                    <i className="fa fa-user"
                    />
                  </div>
                }
              </center>
              <div className="col-10">
                <table>
                  <tbody>
                    <tr>
                      <td>User Name</td>
                      <td>{userDetails.meta.user_name}</td>
                    </tr>
                    <tr>
                      <td>Phone Number</td>
                      <td>{userDetails.meta.user_phone_number}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{userDetails.meta.user_email}</td>
                    </tr>
                    <tr>
                      <td>Verification Status</td>
                      <td>{userDetails.meta.verification_status}</td>
                    </tr>
                    <tr>
                      <td>Role</td>
                      <td>{userDetails.meta.user_role}</td>
                    </tr>

                    <tr>
                      <td>Batch Name</td>
                      <td>{userDetails.meta.batch_name}</td>
                    </tr>
                    {BatchStatus !== "" &&
                      <tr>
                        <td>Batch Status</td>
                        <td>{BatchStatus}</td>
                      </tr>
                    }
                    {/* <tr>
                    <td>Subscription Start Date</td>
                    <td>{userDetails.meta.user_subscription_start}</td>
                  </tr>
                  <tr>
                    <td>Subscription End Date</td>
                    <td>{userDetails.meta.user_subscription_end}</td>
                  </tr> */}
                  </tbody>
                </table>
                {/* <div style={{ margin: "20px 10px" }}>
                <h4>Verification History</h4>
              </div>
              <div>
              </div> */}
              </div>
            </section>
          </div>
          <div className="row">
            <div className="col-2">
            </div>
            <section className="col-8 form-view mt-3">
              <center style={{ margin: "10px" }}>
                <table>
                  <tbody>
                    <tr>
                      <td>Akta</td>
                      <td><img style={{ width: "30px", height: "30px" }} src={userDetails.meta.akta} onClick={() => { setImageSelect(userDetails.meta.akta) }} /></td>
                      <td><div onClick={() => { downloadImage(userDetails.meta.akta, "akta.jpeg") }} className='sign-in-button-111'>Download</div></td>
                    </tr>
                    {userDetails.meta.ak1 !== "" &&
                      <tr>
                        <td>Ak1</td>
                        <td><img src={userDetails.meta.ak1} onClick={() => { setImageSelect(userDetails.meta.ak1) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.ak1, "ak1.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.passpor !== "" &&
                      <tr>
                        <td>Passpor</td>
                        <td><img src={userDetails.meta.passpor} onClick={() => { setImageSelect(userDetails.meta.passpor) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.passpor, "passpor.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.buku_tabungan !== "" &&
                      <tr>
                        <td>Buku Tabungan</td>
                        <td><img src={userDetails.meta.buku_tabungan} onClick={() => { setImageSelect(userDetails.meta.buku_tabungan) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.buku_tabungan, "buku_tabungan.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.foto !== "" &&
                      <tr>
                        <td>Foto</td>
                        <td><img src={userDetails.meta.foto} onClick={() => { setImageSelect(userDetails.meta.foto) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.foto, "foto.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.ijazah !== "" &&
                      <tr>
                        <td>ijazah</td>
                        <td>
                          <a target='_blank' href={userDetails.meta.ijazah} >{userDetails.meta.ijazah.slice(58)}</a>
                          {/* <img src={userDetails.meta.ijazah} onClick={() => { setImageSelect(userDetails.meta.ijazah) }} style={{ width: "30px", height: "30px" }} /> */}
                        </td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.ijazah, "ijazah.pdf") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.kk !== "" &&
                      <tr>
                        <td>kk</td>
                        <td><img src={userDetails.meta.kk} onClick={() => { setImageSelect(userDetails.meta.kk) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.kk, "kk.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.ktp !== "" &&
                      <tr>
                        <td>ktp</td>
                        <td><img src={userDetails.meta.ktp} onClick={() => { setImageSelect(userDetails.meta.ktp) }} style={{ width: "30px", height: "30px" }} /></td>
                        <td><div onClick={() => { downloadImage(userDetails.meta.ktp, "ktp.jpeg") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                    {userDetails.meta.suket_bw !== "" &&
                      <tr>
                        <td>suket_bw</td>
                          <a target='_blank' href={userDetails.meta.suket_bw} >{userDetails.meta.suket_bw.slice(58)}</a>
                          {/* <td><img src={userDetails.meta.suket_bw} onClick={() => { setImageSelect(userDetails.meta.suket_bw) }} style={{ width: "30px", height: "30px" }} /></td> */}
                        <td><div onClick={() => { downloadImage(userDetails.meta.suket_bw, "suket_bw.pdf") }} className='sign-in-button-111'>Download</div></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </center>
            </section>
          </div>
        </>
      }

      {ImageSelect !== "" &&
        <div className="modal center"
          onClick={() => {
            setImageSelect("")
          }}
        >
          <img style={{ height: "100%", width: "100%", objectFit: "contain" }}
            src={ImageSelect}
          />

        </div>
      }

      {editProfileModal &&
        <section className="modal" style={{ padding: "10vh" }}>
          <div className="row">
            <div className="col-lg-3">

            </div>
            <div className="col-lg-6" style={{ backgroundColor: "#fff", padding: "30px" }}>
              <div style={{ textAlign: 'right', fontSize: 22, padding: 10, cursor: 'pointer' }}
                onClick={() => {
                  setEditProfileModal(false)
                }}
              >
                <i className="fa fa-close" />
              </div>
              Edit Profile Picture
              <ImageUpload
                ImageUrl={Photo}
                setImageUrl={setPhoto}
              />
              <div>
                <div style={{ margin: "10px 0 3px" }}><b>Edit Phone Number</b></div>
                <div className="row" >
                  <input className="my-2 p-2 px-2 col-11" style={{ margin: "30px" }}
                    type="text"
                    value={PhoneNumber}
                    onChange={(event) => {
                      setPhoneNumber(event.target.value.replace(/\D/g, ""))
                    }}
                    placeholder="Edit Phone Number"
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-3" />
                <div className="sign-in-button-1 col-6"
                  onClick={() => {
                    EditUser()
                    setEditProfileModal(false)
                  }}
                >
                  Update Profile
                </div>
              </div>
            </div>
            <div className="col-lg-3">

            </div>
          </div>
        </section>

      }


      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent />
      }
    </div >
  )
}